module.exports = __webpack_public_path__ + "static/media/digidrive-desktop-screens.7f0dfbf9.png";